<div class="map-icon icon-general" title="Open Edit Wizard" (click)="openMapEdit()">
	<i class="glyphicons glyphicons-pencil"></i>
</div>
